import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { FileText } from "lucide-react";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ModelSummary({text,title}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const formatMarkdownContent = (content) => {
    return (
      content
        .replace(/\r\n/g, "\n") // Normalize Windows line breaks
        .replace(/\t/g, "") // Remove tab characters
        
        // Dynamic section headers - any line ending with colon becomes a header
        .replace(
          /^([A-Za-z\s]+):\s*$/gm,
          '</ul><div class="text-lg font-bold text-[#0000a0] mt-2 mb-1">$1</div><ul class="list-disc ml-6 space-y-0">'
        )

        // Enhanced list item formatting with minimal spacing
        .replace(/^•\s*(.*$)/gm, '<li class="text-gray-700 leading-tight py-0.5">$1</li>')
        .replace(/^[-]\s*(.*$)/gm, '<li class="text-gray-700 leading-tight py-0.5">$1</li>')

        // Bold text formatting
        .replace(
          /\*\*(.*?)\*\*/g,
          '<strong class="font-semibold text-gray-900">$1</strong>'
        )
        .replace(/\*(.*?)\*/g, '<em class="italic text-blue-700">$1</em>')

        // Paragraph formatting with proper spacing
        .replace(/\n{2,}/g, '</ul><p class="text-gray-700 leading-relaxed mb-4">') // double newlines → paragraph
        .replace(/\n/g, '<br>') // single newline → line break
        
        // Wrap content in proper structure
        .replace(/^(.*?)(?=<div class="text-xl font-bold"|$)/s, '<div class="text-gray-700 leading-relaxed mb-4">$1</div>')
        
        .concat("</ul>")
    );
  };
  return (
    <React.Fragment>
      <button
        onClick={handleClickOpen}
        style={{background:"#fff", color:"#404040"}}
        className="flex items-center justify-center gap-2 px-4 h-[40px] rounded-xl shadow-lg whitespace-nowrap group border border-[#818181] br-[8px]"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-700 to-blue-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <FileText className="w-4 h-4 relative z-10 text-[#404040] " />
        <span className="relative z-10 text-base font-semibold text-[#404040]  font-medium ">
          Read More
        </span>
        <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
      </button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Modal title
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <div
            style={{ zIndex: "99999", backgroundColor: "rgba(0,0,0,0.8)" }}
            className="fixed inset-0  flex items-center justify-center p-4 z-50 animate-fadeIn"
          >
            <div className="bg-white rounded-3xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden animate-slideUp">
              {/* Header with gradient accent */}
              <div className="relative">
                {/* <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-white to-white"></div> */}
                <div className="flex items-center justify-between pt-4 pl-4 pr-8 pb-4 border-b border-[#0000a0] bg-gradient-to-r from-white to-white">
                  <div className="flex  gap-4 items-center justify-start">
                    <div
                      style={{ width: "40px" }}
                      className=" h-12 bg-gradient-to-r from-white to-white  border border-[#0000a0]  rounded-xl flex items-center justify-center"
                    >
                      <FileText className="w-6 h-6 text-[#0000a0]" />
                    </div>
                    <div>
                      <h2 className="text-4xl font-bold text-[#0000a0] leading-tight">
                        {title}
                      </h2>
                      {/* <p className="text-sm text-gray-500 mt-1 text-left">Summary of {title}</p> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Content with improved typography */}
              <div className="p-6 overflow-y-auto max-h-[60vh]">
                <div className="rounded-2xl p-6 border border-gray-200 bg-gray-50/30">
                  <div
                    className="text-left prose prose-lg max-w-none"
                    dangerouslySetInnerHTML={{
                      __html: formatMarkdownContent(text),
                    }}
                  />
                </div>
              </div>

              {/* Footer with enhanced buttons */}
              <div className="flex items-center justify-between p-4 pr-5 border-t border-[#0000a0] bg-gradient-to-r from-white to-white">
                <div className="text-sm text-gray-500"></div>
                <div className="flex items-center gap-4">
                  <button
                    onClick={handleClose}
                    //   style={{border:"1px solid #283978",color:"#283978"}}
                    className="px-6 py-2 border-1 border-[#0000a0] rounded-xl font-medium text-[#0000a0] hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 hover:shadow-sm"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
